var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('UiPageHeader',{scopedSlots:_vm._u([{key:"default",fn:function(){return [_vm._v(_vm._s(_vm.$t('SSO')))]},proxy:true}])}),_c('div',{staticClass:"tw-py-4 tw-px-6"},[_c('Security')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }